<template>
  <div
    class="module-section"
  >
    <div
      v-if="icon !== '' && title !== ''"
      class="module-section__header"
    >
      <div class="module-section__icon" v-html="icon"></div>
      <h4 class="module-section__title">{{ title }}</h4>
    </div>

    <div class="module-section__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleSection',
  props: {
    icon: {
      type: String,
      default: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><g><path d="M7.28,9.37a1.31,1.31,0,0,0,1.94,0l.63-.7a1.3,1.3,0,0,1,2.27.95l0,.93a1.3,1.3,0,0,0,1.37,1.37l.94-.05a1.31,1.31,0,0,1,.94,2.28l-.7.62a1.33,1.33,0,0,0-.43,1,1.31,1.31,0,0,0,.43,1l.7.63a1.31,1.31,0,0,1,.33,1.47,1.3,1.3,0,0,1-1.27.8l-.94,0a1.3,1.3,0,0,0-1.37,1.37l0,.93a1.3,1.3,0,0,1-2.27.94l-.63-.69a1.31,1.31,0,0,0-1.94,0l-.63.69a1.3,1.3,0,0,1-2.27-.94l0-.93a1.3,1.3,0,0,0-1.37-1.37l-.94,0a1.3,1.3,0,0,1-1.27-.8,1.31,1.31,0,0,1,.33-1.47l.7-.63a1.31,1.31,0,0,0,.43-1,1.33,1.33,0,0,0-.43-1l-.7-.62a1.31,1.31,0,0,1,.94-2.28l.94.05a1.3,1.3,0,0,0,1.37-1.37l0-.93a1.3,1.3,0,0,1,2.27-.95Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><circle cx="8.25" cy="15.74" r="1.88" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></circle><path d="M18.26,5.25a.5.5,0,0,0-.5.5.5.5,0,0,0,1,0,.5.5,0,0,0-.5-.5h0" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M21,1.93a.8.8,0,0,1,.86.18.83.83,0,0,1,.19.87l-.54,1.39a.82.82,0,0,0,.24.93L23,6.23a.79.79,0,0,1,.27.84.8.8,0,0,1-.66.6l-1.47.22a.82.82,0,0,0-.68.68l-.23,1.48a.81.81,0,0,1-1.43.38l-.94-1.16A.79.79,0,0,0,16.89,9l-1.39.54a.81.81,0,0,1-1.05-1.05L15,7.12a.84.84,0,0,0-.25-.93l-1.17-.93A.82.82,0,0,1,14,3.82l1.47-.22a.82.82,0,0,0,.68-.68l.23-1.48a.83.83,0,0,1,.59-.66.82.82,0,0,1,.84.28l.94,1.16a.79.79,0,0,0,.92.25Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g></g></svg>'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
/**
 * Module Content
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Content wrapper for the modules
 * @since 2021-08-23
**/

$component: 'module-section';

.#{$component} {
  @include margin-bottom(map-get($spacers, 5));

  &__header {
    display: flex;
    align-items: flex-start;
    @include margin-bottom(map-get($spacers, 2));
  }

  &__icon {
    @include rfs(1.5rem, flex-basis);
    @include margin-right(map-get($spacers, 2));
    color: $ink;

    svg {
      width: 100%;
      height: auto;
      aspect-ratio: 1 / 1;
      color: $ink;
      stroke: $ink;

      path {
        stroke: $ink;
      }
    }
  }

  &__title {
    width: 100%;
    // @include padding-bottom(map-get($spacers, 2));
    // border-bottom: 1px solid $gray-ghost;
    @include font-size($font-size-xl);
  }

  &__content {
    ::v-deep {
      .form-input.--is-radio + .form-input.--is-radio,
      .form-input.--is-checkbox + .form-input.--is-checkbox {
        @include margin-top(map-get($spacers, 2));
      }

      hr {
        @include margin(map-get($spacers, 4) 0);
        border: 0;
        opacity: 1;
        background-color: $gray-ghost;
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
